import classifyPoint from 'robust-point-in-polygon';
import Bullet from './bullet';
import gsap from 'gsap';

class Fighter {
    constructor(pos, isUser, name, onDeath, size) {
        this.x = pos[0];
        this.y = pos[1];
        this.name = name;
        this.jump = {y: 0};
        this.sizeMult = {s: 1}
        this.fireLock = 100;
        this.fireInt = random(this.fireLock*.75);
        this.fighterSize = size;
        this.highlight = isUser;
        this.status = 'fighting';
        this.highlightPhase = {
            y: 0,
            opacity: 0
        }
        this.onDeath = onDeath;

        if(isUser) {
            const tl = gsap.timeline({repeat: 9999, yoyo: false});
            tl.to(this.highlightPhase, {y: 5, duration:.5});
            tl.to(this.highlightPhase, {y: -5, duration:1});
            gsap.to(this.highlightPhase, {opacity:255, duration:1})
        }
    }
    updateLife(blobBounds) {
        const inside = classifyPoint(blobBounds, [this.x, this.y]);
        if(inside !== 1 && this.status !== 'dead') {
            this.status = 'dead';
            this.onDeath(this.name);
        }
    }
    beginCelebrating() {
        if(this.status === 'fighting') {
            this.status = 'celebrate';
            this.fireInt = 0;
            const oS = random(5);
            var tl = gsap.timeline({repeat: 9999, repeatDelay: oS, delay: oS+1});
            
            tl.to(this.jump, {y: this.fighterSize*4, duration:.4, ease:
            'circ.out'})
            .to(this.jump, {y: 0, duration:.4, ease: 'circ.in'});
        }
    }

    intro() {
        this.status = 'intro';
        this.sizeMult.s = 0;
        const oS = random(1.5);
        gsap.to(this.sizeMult, {s: 1, duration: .5, delay: oS})
    }

    beginFighting() {
        this.status = 'fighting';
    }

    draw() {
        const mult = this.fireInt / this.fireLock;
        const radius = 3;//mult * this.fighterSize;
        let size = (this.fighterSize + 3 * mult) * this.sizeMult.s;
        const fillOpacity = 150 + 100*mult;
        if(this.status === 'dead') {
            size = this.fighterSize;
            fill(0, 0, 0);
        }
        else {
            fill(255, 255, 255, fillOpacity);
        }
        
        rect(this.x - size/2, this.y - size/2 - this.jump.y, size, size, radius, radius, radius, radius);

        if(this.highlight && this.status !== 'dead') {
            const rectWidth = 34;
            const rectHeight = 22;
            const oS = 25 + this.highlightPhase.y;
            fill(247, 173, 11, this.highlightPhase.opacity);
            rect(this.x - rectWidth/2, this.y - rectHeight/2-oS, rectWidth, rectHeight);
            beginShape();
            vertex(this.x - 5, this.y-oS+rectHeight/2);
            vertex(this.x + 5, this.y-oS+rectHeight/2);
            vertex(this.x, this.y-oS+rectHeight/2+10);
            endShape();
            fill(255, this.highlightPhase.opacity);
            textSize(18);
            textAlign(CENTER);
		    textFont('VT323');
            text("YOU!", this.x, this.y+rectHeight/4-oS);
        }
    }
    canFire() {
        this.fireInt++;
        let shouldFire = false;
        if(this.fireInt > this.fireLock && this.status === 'fighting') {
            shouldFire = true;
            this.fireInt = 0;
        }
        else {
            shouldFire = false;
        }
        return shouldFire;
    }
    fireBullet() {
        if(this.canFire()) {
            return new Bullet(this.x, this.y, this.canvas);
        }
        else return false;

    }
}

const getFighterPositions = (numOfFighters, width, height, safetyRingAroundBlob) => {
    const res = [];
    const radius = 6;

    for(let i = 0; i < numOfFighters; i++) {
        const pos = getPosition(width, height, radius, res, safetyRingAroundBlob);
        res.push(pos);
    }

    return res;
}

const getPosition = (width, height, radius, list, safetyRingAroundBlob) => {
    const x = radius + random()*(width-radius)
    const y = radius + random()*(height-radius)

    const touchesCenter = (x - radius < width/2 + safetyRingAroundBlob && x + radius > width/2-safetyRingAroundBlob &&
               y - radius < height/2 + safetyRingAroundBlob && y + radius > height/2-safetyRingAroundBlob);
    
    if(touchesCenter) {
        return getPosition(width, height, radius, list);
    }

    const overlap = list.some(f => {
        return (f[0] - radius < x + radius && f[0] + radius > x-radius && 
               f[1] - radius < y + radius && f[1] + radius > y-radius);
    });
    if(overlap) {
        return getPosition(width, height, radius, list);
    }
    return [x, y];
}

export {getFighterPositions};
export default Fighter;